import api from 'api';

export const loadPostbacksReport = api('POST /api/postbacks-report/grid');

export const exportCSV = api('POST /api/postbacks-report/export-csv', {
  responseType: 'blob',
});

export const sendToEmail = api('POST /api/postbacks-report/send-to-email');
